import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { pluckNumber, extend2, getDarkColor, getLightColor } from '../../../../fc-core/src/lib';
import * as defaultPaletteOptions from './chart-palette-colors';
import isArray from '../../../../fc-utils/src/type/is-array';

function parseColorMix(a, b) {
  var c,
      d,
      e,
      f,
      g,
      h,
      k,
      l,
      m,
      n,
      o,
      p = [],
      q = ColorManager.stringConstants;
  if (b = b.replace(/\s/g, q.BLANK), b = b.toLowerCase(), b === q.BLANK || null === b || 'undefined' == typeof b) p = [a];else for (e = b.split(q.COMMASTRING), f = a.split(q.COMMASTRING), g = Math.max(e.length, f.length, 1), h = e[0], k = f[0], n = /[\{\}]/ig, o = 0; o < g; o++) {
    l = (e[o] || h).replace(n, ''), m = f[o] || k, 'color' === l ? p.push(m) : 'light' === l.substr(0, 5) ? (c = l.indexOf('-'), d = -1 === c ? 1 : l.substr(c + 1, l.length - c), d = 100 - d, p.push(getLightColor(m, d))) : 'dark' === l.substr(0, 4) ? (c = l.indexOf('-'), d = -1 === c ? 1 : l.substr(c + 1, l.length - c), d = 100 - d, p.push(getDarkColor(m, d))) : p.push(l);
  }
  return p;
}

function parseAlphaList(a, b) {
  var c,
      d,
      e = a.toString().split(ColorManager.stringConstants.COMMASTRING),
      f = [],
      g = 100;

  for (d = 0; d < b; d++) {
    c = pluckNumber(e[d]), ColorManager.defined(c) && (g = c), f[d] = g;
  }

  return f.join();
}

function parseRatioList(a, b) {
  var c,
      d,
      e = a.split(ColorManager.stringConstants.COMMASTRING),
      f = [],
      g = 0;

  for (d = 0; d < b; d++) {
    c = e[d], c = isNaN(c) || 'undefined' == typeof c ? 0 : Math.abs(+c), c = 100 < c ? 100 : c, f[d] = c, g += c;
  }

  if (g = 100 < g ? 100 : g, e.length < b) for (d = e.length; d < b; d++) {
    f[d] = (100 - g) / (b - e.length);
  }
  return f[-1] = 0, f.join();
}

var ColorManager =
/*#__PURE__*/
function () {
  function ColorManager(a) {
    _classCallCheck(this, ColorManager);

    this.parseColorMix = parseColorMix, this.parseAlphaList = parseAlphaList, this.parseRatioList = parseRatioList, this.linkedItems = {
      iapi: a
    }, this.configure(), this.paletteColors = ['AFD8F8', 'F6BD0F', '8BBA00', 'FF8E46', '008E8E', 'D64646', '8E468E', '588526', 'B3AA00', '008ED6', '9D080D', 'A186BE', 'CC6600', 'FDC689', 'ABA000', 'F26D7D', 'FFF200', '0054A6', 'F7941C', 'CC3300', '006600', '663300', '6DCFF6'];
  }

  _createClass(ColorManager, [{
    key: "configure",
    value: function configure() {
      var a = this,
          b = ColorManager.stringConstants,
          c = a.linkedItems.iapi,
          d = c.getFromEnv('dataSource'),
          e = d.chart || {},
          f = a.paletteOptions = extend2(extend2({}, defaultPaletteOptions), c.defaultPaletteOptions || {}, !1, !0),
          g = a.themeEnabled = e.palettethemecolor;
      a.paletteIndex = (0 < e.palette && 6 > e.palette ? e.palette : pluckNumber(c.paletteIndex, 1)) - 1, a.iterator = 0, a.paletteColors = f.paletteColors[a.themeEnabled ? 0 : a.paletteIndex], ColorManager.defined(e.palettecolors) && e.palettecolors !== b.BLANK && (a.paletteColors = isArray(e.palettecolors) ? e.palettecolors.slice() : e.palettecolors.split(/\s*\,\s*/)), a.paletteLen = a.paletteColors.length, a.useFlatColors = pluckNumber(e.useflatdataplotcolor, c.useFlatColor, 0), g && (a.paletteIndex = 5, f.bgColor[5] = getLightColor(g, 35) + b.COMMASTRING + getLightColor(g, 10), f.bgAngle[5] = 270, f.bgRatio[5] = b.BGRATIOSTRING, f.bgAlpha[5] = '50,50', f.canvasBgColor[5] = b.COLOR_WHITE, f.canvasBgAngle[5] = 0, f.canvasBgAlpha[5] = b.HUNDREDSTRING, f.canvasBgRatio[5] = b.BLANK, f.canvasBorderColor[5] = getDarkColor(g, 80), f.canvasBorderAlpha[5] = 100, f.showShadow[5] = 1, f.divLineColor[5] = getDarkColor(g, 20), f.divLineAlpha[5] = 40, f.altHGridColor[5] = getLightColor(g, 20), f.altHGridAlpha[5] = 15, f.altVGridColor[5] = getLightColor(g, 80), f.altVGridAlpha[5] = 10, f.anchorBgColor[5] = b.COLOR_WHITE, f.toolTipBgColor[5] = b.COLOR_WHITE, f.toolTipBorderColor[5] = getDarkColor(g, 80), f.baseFontColor[5] = g.split && g.split(b.COMMASTRING)[0], f.borderColor[5] = getDarkColor(g, 60), f.borderAlpha[5] = 50, f.legendBgColor[5] = b.COLOR_WHITE, f.legendBorderColor[5] = getDarkColor(g, 80), f.plotGradientColor[5] = b.COLOR_WHITE, f.plotBorderColor[5] = getDarkColor(g, 85), f.plotFillColor[5] = getDarkColor(g, 85), f.bgColor3D[5] = b.COLOR_WHITE, f.bgAlpha3D[5] = b.HUNDREDSTRING, f.bgAngle3D[5] = 90, f.bgRatio3D[5] = b.BLANK, f.canvasBgColor3D[5] = getLightColor(g, 20), f.canvasBaseColor3D[5] = getLightColor(g, 40), f.divLineColor3D[5] = getDarkColor(g, 20), f.divLineAlpha3D[5] = 40, f.legendBgColor3D[5] = b.COLOR_WHITE, f.legendBorderColor3D[5] = getDarkColor(g, 80), f.toolTipbgColor3D[5] = b.COLOR_WHITE, f.toolTipBorderColor3D[5] = getDarkColor(g, 80), f.baseFontColor3D[5] = g.split && g.split(b.COMMASTRING)[0], f.anchorBgColor3D[5] = b.COLOR_WHITE, f.tickColor && (f.tickColor[5] = getDarkColor(g, 90)), f.trendDarkColor && (f.trendDarkColor[5] = getDarkColor(g, 90)), f.trendLightColor && (f.trendLightColor[5] = getLightColor(g, f.TrendLightShadeOffset)), f.msgLogColor && (f.msgLogColor[5] = getLightColor(g, 80)), f.dialColor && (f.dialColor[5] = getDarkColor(g, 95) + ',FFFFFF,' + getDarkColor(g, 95)), f.dialBorderColor && (f.dialBorderColor[5] = getDarkColor(g, 95) + ',FFFFFF,' + getDarkColor(g, 95)), f.pivotColor && (f.pivotColor[5] = getLightColor(g, 95) + ',FFFFFF,' + getLightColor(g, 95)), f.pivotBorderColor && (f.pivotBorderColor[5] = getDarkColor(g, 95) + ',FFFFFF,' + getDarkColor(g, 95)), f.pointerBorderColor && (f.pointerBorderColor[5] = getDarkColor(g, 75)), f.pointerBgColor && (f.pointerBgColor[5] = getDarkColor(g, 75)), f.thmBorderColor && (f.thmBorderColor[5] = getDarkColor(g, 90)), f.thmFillColor && (f.thmFillColor[5] = getLightColor(g, 55)), f.gaugeBorderColor && (f.gaugeBorderColor[5] = getDarkColor(g, 90)), f.gaugeFillColor && (f.gaugeFillColor[5] = getLightColor(g, 55)), f.cylFillColor && (f.cylFillColor[5] = getLightColor(g, 55)), f.periodColor && (f.periodColor[5] = getLightColor(g, 10)), f.winColor && (f.winColor[5] = '666666'), f.lossColor && (f.lossColor[5] = 'CC0000'), f.drawColor && (f.drawColor[5] = '666666'), f.scorelessColor && (f.scorelessColor[5] = 'FF0000'), f.gridColor && (f.gridColor[5] = getLightColor(g, 30)), f.categoryBgColor && (f.categoryBgColor[5] = getLightColor(g, 10)), f.dataTableBgColor && (f.dataTableBgColor[5] = getLightColor(g, 10)), f.gridResizeBarColor && (f.gridResizeBarColor[5] = getDarkColor(g, 90)), f.scrollBarColor && (f.scrollBarColor[5] = getLightColor(g, 50)));
    }
  }, {
    key: "getColor",
    value: function getColor(a) {
      return this.paletteOptions[a][this.paletteIndex];
    }
  }, {
    key: "getPlotColor",
    value: function getPlotColor(a) {
      var b = this,
          c = b.paletteColors,
          d = b.useFlatColors ? b.getColor('plotFillColor') : c[a % b.paletteLen];
      return d || (b.iterator === b.paletteLen && (b.iterator = 0), d = c[b.iterator], b.iterator += 1), d;
    }
  }]);

  return ColorManager;
}();

ColorManager.stringConstants = {
  BLANK: '',
  COMMASTRING: ',',
  BGRATIOSTRING: '0,100',
  COLOR_WHITE: 'FFFFFF',
  HUNDREDSTRING: '100'
}, ColorManager.defined = function (a) {
  return 'undefined' != typeof a && null !== a;
};
export default ColorManager;